import {
    allFetch
} from "../Domain";

/**
 * @description 簽核項目&欄位設定
 */
export const SignOffSetting = (() => {

    /**
     * 查詢簽核項目
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} disable 是否禁用
     * @returns 
     */
    const SignOffSettingMasterSearch = async function (obj = { sosm_id: "", disable: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingMasterSearch', obj);
    }

    /**
     * 簽核項目細項
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffSettingMasterDetail = async function (obj = { sosm_id: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingMasterDetail', obj);
    }

    /**
     * 新增簽核設定主項
     * @param {*} sosm_name 簽核設定主項名稱
     * @returns 
     */
    const SignOffSettingMasterCreate = async function (obj = { sosm_name: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingMasterCreate', obj);
    }

    /**
     * 修改簽核設定主項
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} sosm_name 簽核設定主項名稱
     * @param {*} disable 是否禁用
     * @returns 
     */
    const SignOffSettingMasterUpdate = async function (obj = { sosm_id: "", sosm_name: "", disable: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingMasterUpdate', obj);
    }

    /**
     * 刪除簽核設定主項
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffSettingMasterDelete = async function (obj = { sosm_id: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingMasterDelete', obj);
    }

    /**
     * (第一次)新增一堆簽核設定細項
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {SignOffSettingDetail_obj[]} list 欄位資訊們
     * @returns 
     */
    const SignOffSettingDetailCreate = async function (obj = { sosm_id: "", list: new Array() }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailCreate', obj);
    }

    /**
     * 增加一條簽核設定細項
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} column_name 欄位名稱
     * @param {*} is_encryption 欄位是否加密
     * @param {*} is_require 欄位是否必填
     * @param {*} data_type 資料型態
     * @param {*} seq 順序
     * @returns 
     */
    const SignOffSettingDetailAdd = async function (obj = { sosm_id: "", column_name: "", is_encryption: "", is_require: "", data_type: "", seq: 0 }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailAdd', obj);
    }

    /**
     * 修改簽核設定細項
     * @param {*} sosd_id 簽核設定細項流水號
     * @param {*} column_name 欄位名稱
     * @param {*} is_encryption 欄位是否加密
     * @param {*} is_require 欄位是否必填
     * @param {*} data_type 資料型態
     * @param {*} seq 順序
     * @returns 
     */
    const SignOffSettingDetailUpdate = async function (obj = { sosd_id: "", column_name: "", is_encryption: "", is_require: "", data_type: "", seq: 0 }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailUpdate', obj);
    }

    /**
     * 刪除簽核設定細項
     * @param {*} sosd_id 簽核設定細項流水號
     * @returns 
     */
    const SignOffSettingDetailDelete = async function (obj = { sosd_id: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailDelete', obj);
    }

    /**
     * 查詢簽核設定細項
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffSettingDetailSearch = async function (obj = { sosm_id: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailSearch', obj);
    }

    /**
     * 新增簽核設定細項選項
     * @param {*} sosd_id 簽核設定細項流水號
     * @param {*} option 選項
     * @returns 
     */
    const SignOffSettingDetailOptionCreate = async function (obj = { sosd_id: "", option: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailOptionCreate', obj);
    }

    /**
     * 修改簽核設定細項選項
     * @param {*} sosdo_id 簽核設定細項選項流水號
     * @param {*} sosd_id 簽核設定細項流水號
     * @param {*} option 選項
     * @returns 
     */
    const SignOffSettingDetailOptionUpdate = async function (obj = { sosdo_id: "", sosd_id: "", option: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailOptionUpdate', obj);
    }

    /**
     * 刪除簽核設定細項選項
     * @param {*} sosdo_id 簽核設定細項選項流水號
     * @param {*} sosd_id 簽核設定細項流水號
     * @returns 
     */
    const SignOffSettingDetailOptionDelete = async function (obj = { sosdo_id: "", sosd_id: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailOptionDelete', obj);
    }

    /**
     * 查詢簽核設定細項選項
     * @param {*} sosd_id 簽核設定細項流水號
     * @returns 
     */
    const SignOffSettingDetailOptionSearch = async function (obj = { sosd_id: "" }) {
        return await allFetch('SignOffSetting/SignOffSettingDetailOptionSearch', obj);
    }


    // 簽核審核規則設定

    /**
     * 新建簽核審核規則設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} ul_id 職務流水號
     * @param {*} audit_type 審核類型
     * @returns 
     */
    const SignOffAuditSettingCreate = async function (obj = { sosm_id: "", ul_id: "", audit_type: "" }) {
        return await allFetch('SignOffSetting/SignOffAuditSettingCreate', obj);
    }

    /**
     * 修改簽核審核規則設定
     * @param {*} soas_id 簽核審核規則設定流水號
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} ul_id 職務流水號
     * @param {*} audit_type 審核類型
     * @returns 
     */
    const SignOffAuditSettingUpdate = async function (obj = { soas_id: "", sosm_id: "", ul_id: "", audit_type: "" }) {
        return await allFetch('SignOffSetting/SignOffAuditSettingUpdate', obj);
    }

    /**
     * 刪除簽核審核規則設定
     * @param {*} soas_id 簽核審核規則設定流水號
     * @returns 
     */
    const SignOffAuditSettingDelete = async function (obj = { soas_id: "" }) {
        return await allFetch('SignOffSetting/SignOffAuditSettingDelete', obj);
    }

    /**
     * 查詢簽核審核規則設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffAuditSettingSearch = async function (obj = { sosm_id: "" }) {
        return await allFetch('SignOffSetting/SignOffAuditSettingSearch', obj);
    }


    // 簽核插入規則設定

    /**
     * 新建簽核插入規則設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} ul_id 職務流水號
     * @param {*} insert_position 插入位置
     * @returns 
     */
    const SignOffInsertSettingCreate = async function (obj = { sosm_id: "", ul_id: "", insert_position: "" }) {
        return await allFetch('SignOffSetting/SignOffInsertSettingCreate', obj);
    }

    /**
     * 修改簽核插入規則設定
     * @param {*} sois_id 簽核插入規則設定流水號
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} ul_id 職務流水號
     * @param {*} insert_position 插入位置
     * @returns 
     */
    const SignOffInsertSettingUpdate = async function (obj = { sois_id: "", sosm_id: "", ul_id: "", insert_position: "" }) {
        return await allFetch('SignOffSetting/SignOffInsertSettingUpdate', obj);
    }

    /**
     * 刪除簽核插入規則設定
     * @param {*} sois_id 簽核插入規則設定流水號
     * @returns 
     */
    const SignOffInsertSettingDelete = async function (obj = { sois_id: "" }) {
        return await allFetch('SignOffSetting/SignOffInsertSettingDelete', obj);
    }

    /**
     * 查詢簽核插入規則設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffInsertSettingSearch = async function (obj = { sosm_id: "" }) {
        return await allFetch('SignOffSetting/SignOffInsertSettingSearch', obj);
    }


    // 簽核條件規則設定

    /**
     * 新建簽核條件規則設定
     * @param {*} sosd_id 簽核設定細項流水號
     * @param {*} ul_id 職務流水號
     * @param {*} threshold 門檻
     * @returns 
     */
    const SignOffConditionSettingCreate = async function (obj = { sosd_id: "", ul_id: "", threshold: "" }) {
        return await allFetch('SignOffSetting/SignOffConditionSettingCreate', obj);
    }

    /**
     * 修改簽核條件規則設定
     * @param {*} socs_id 簽核條件規則設定流水號
     * @param {*} sosd_id 簽核設定細項流水號
     * @param {*} ul_id 職務流水號
     * @param {*} threshold 門檻
     * @returns 
     */
    const SignOffConditionSettingUpdate = async function (obj = { socs_id: "", sosd_id: "", ul_id: "", threshold: "" }) {
        return await allFetch('SignOffSetting/SignOffConditionSettingUpdate', obj);
    }

    /**
     * 刪除簽核條件規則設定
     * @param {*} socs_id 簽核條件規則設定流水號
     * @returns 
     */
    const SignOffConditionSettingDelete = async function (obj = { socs_id: "" }) {
        return await allFetch('SignOffSetting/SignOffConditionSettingDelete', obj);
    }

    /**
     * 查詢簽核條件規則設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffConditionSettingSearch = async function (obj = { sosm_id: "" }) {
        return await allFetch('SignOffSetting/SignOffConditionSettingSearch', obj);
    }


    // 簽核通知設定

    /**
     * 修改簽核通知設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @param {*} user_ids 使用者流水號們
     * @param {*} ul_ids 職務流水號們
     * @returns 
     */
    const SignOffNoticeSettingUpdate = async function (obj) {
        let { sosm_id = '', user_ids = [], ul_ids = [] } = obj;
        return await allFetch('SignOffSetting/SignOffNoticeSettingUpdate', { sosm_id, user_ids, ul_ids });
    }

    /**
     * 查詢簽核通知設定
     * @param {*} sosm_id 簽核設定主項流水號
     * @returns 
     */
    const SignOffNoticeSettingSearch = async function (obj) {
        let { sosm_id = '' } = obj;
        return await allFetch('SignOffSetting/SignOffNoticeSettingSearch', { sosm_id });
    }

    return {
        SignOffSettingMasterSearch,
        SignOffSettingMasterDetail,
        SignOffSettingMasterCreate,
        SignOffSettingMasterUpdate,
        SignOffSettingMasterDelete,
        SignOffSettingDetailCreate,
        SignOffSettingDetailAdd,
        SignOffSettingDetailUpdate,
        SignOffSettingDetailDelete,
        SignOffSettingDetailSearch,
        SignOffSettingDetailOptionCreate,
        SignOffSettingDetailOptionUpdate,
        SignOffSettingDetailOptionDelete,
        SignOffSettingDetailOptionSearch,
        SignOffAuditSettingCreate,
        SignOffAuditSettingUpdate,
        SignOffAuditSettingDelete,
        SignOffAuditSettingSearch,
        SignOffInsertSettingCreate,
        SignOffInsertSettingUpdate,
        SignOffInsertSettingDelete,
        SignOffInsertSettingSearch,
        SignOffConditionSettingCreate,
        SignOffConditionSettingUpdate,
        SignOffConditionSettingDelete,
        SignOffConditionSettingSearch,
        SignOffNoticeSettingUpdate,
        SignOffNoticeSettingSearch
    }
})();


/**
 * 欄位資訊
 * @param {*} column_name 欄位名稱
 * @param {*} is_encryption 欄位是否加密
 * @param {*} is_require 欄位是否必填
 * @param {*} data_type 資料型態
 * @param {*} seq 順序
 */
export class SignOffSettingDetail_obj {
    constructor(column_name, is_encryption, is_require, data_type, seq) {
        this.column_name = column_name;
        this.is_encryption = is_encryption;
        this.is_require = is_require;
        this.data_type = data_type;
        this.seq = seq;
    }
}